/**
 * Created by synerzip on 08/02/16.
 */
import React from 'react';
import { bindActionCreators } from 'redux';
import * as adminActionCreator from '../../actions/admin';
import * as commonActionCreator from '../../actions/common';
import { connect } from 'react-redux';
import {Input,Modal,Button,FieldGroup} from 'react-bootstrap';
import _ from 'lodash';
import moment from 'moment';
import DateTimeField from 'react-bootstrap-datetimepicker-custom-icons';
import Dropzone from 'react-dropzone';

class AddConfidentialDocument extends React.Component {

    constructor(props){
        super(props);
        const {activeUser} = props;
        this.state={
            name:'',
            file:null
        }
    }
    
    showErrorMessage(title,message){
        this.props.commonActions.showToast({
            status: 'error',
            title: title,
            message: message
        });
        var interval = setInterval(()=> {
            clearInterval(interval);
            this.props.commonActions.hideToast();
        }, 2);
    }
    validateAndSubmitData(addAnother){
        if( this.state.name.trim() === ''){
            this.showErrorMessage('Invalid Name','Please provide a valid name for document');
            return;
        } else if(!this.state.file){
            this.showErrorMessage('Invalid Document','Please upload document');
            return;
        }
    }
    onSubmit(e) {
        e.preventDefault();
        this.validateAndSubmitData();
        this.props.adminActions.uploadConfidentialDoc(this.props.selectedPatient.id,this.state.file,this.state.name, (hasError) => {
            this.onCancel();
        } );

    }

    clearCurrentTodoData(){
        this.currentTodoData = null;
        this.setState({
            show:false,
        })
    }

    onCancel() {
        this.props.showSecondaryTimer();
        this.setState(
            {
                name:'',
                file:null
            }
        );
        this.props.onPopupHide();
    }

    render() {
    	const { name,file } = this.state;
        return (
            <Modal show={this.props.show}>
                <Modal.Header closeButton onHide={()=>{
                                this.props.onPopupHide();
                            }}>
                    <Modal.Title>
                        <div style={
                            {
                            textAlign: 'center'
                            }
                        }>
                            <div>Add Document</div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="clearfix">
                           <form onSubmit={this.onSubmit.bind(this)}> 
                                <div>
                                    <Input rows="8" type="text" label="Name" placeholder="Name" required
                                        value={this.state.name || ''}
                                        onChange={(e) => this.setState({ name: e.target.value })} maxLength="1024"/>

                                     <label>Upload File</label>    
                                     <Dropzone multiple={false} 
                                        accept="application/pdf"
                                        style={{width:'100%',height:200,
                                            borderWidth:2,borderColor:'#666',
                                            borderStyle:'dashed',borderRadius:5}}
                                        onDrop={(files) => this.setState({file: files[0]})}>
                                            <div style={{display:'flex', flex:1, height:'100%', 
                                                width:'100%', alignItems:'center', justifyContent:'center'}}>
                                                {
                                                    this.state.file ? 
                                                    <div>{this.state.file.name}</div>
                                                    :
                                                    <div>Drag and drop or browse to select file.</div>
                                                }
                                            </div>
                                    </Dropzone>    
                                                        
                                </div>
                                <div style={{textAlign:'center',paddingTop:10}}>
                                    <Button bsStyle="danger" onClick={this.onCancel.bind(this)} style={{float:'left'}}>
                                        Cancel
                                    </Button>
                                    <Button bsStyle="success" type="submit" style={{float:'right'}}
                                        disabled = {!file || !name}>
                                        Save
                                    </Button>
                                </div>
                        </form>
                    </div>


                </Modal.Body>

            </Modal>
        );

    }
}
const mapStateToProps = (state) => ({
	'activeUser': state.admin.activeUser,
	'user': state.auth.user,
    'selectedPatient':state.app.selectedPatient,
    'urgentTypes': state.app.urgentTypes,
    'patient': state.app.selectedPatient,
    'selectedPatientPharmacyOptions':state.app.selectedPatientPharmacyOptions,
    'patientCcmProviders': state.app.patientCcmProviders,
    'selectedPatientChartspanProviders':state.app.selectedPatientChartspanProviders,
    'selectedPatientMedicationOptions':state.app.selectedPatientMedicationOptions
});

const mapDispatchToProps = (dispatch) => ({
    adminActions: bindActionCreators(adminActionCreator, dispatch),
    commonActions: bindActionCreators(commonActionCreator, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddConfidentialDocument);
